import styled from 'styled-components';
import theme from '../../feachers/theme';
import { ModalContentWrap } from '../../components/Modal/Modal.parts';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  max-width: 900px;
  padding: 0 10px;
  text-align: center;
`;

export const YellowCard = styled.div`
  background: #F1D797;
  border-radius: 24px;
  padding: 40px;
  width: 100%;
  max-width: 800px;
  text-align: center;

  @media screen and ${theme.breakpoints.mobile} {
    padding: 24px 16px;
  }
`;

export const LoginCard = styled.div`
  background: #787d2f;
  border-radius: 24px;
  padding: 40px;
  width: 100%;
  max-width: 800px;
  margin-top: 20px;
  text-align: center;

  @media screen and ${theme.breakpoints.mobile} {
    padding: 24px 16px;
  }
`;

export const LoginCardTitle = styled.h3`
  font-family: 'Mix Pudgy Panda';
  font-size: 24px;
  color: #ffffff;
  margin: 0 0 10px 0;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 1.5px;

  @media screen and ${theme.breakpoints.mobile} {
    font-size: 20px;
  }
`;

export const LoginCardText = styled.p`
  font-family: 'Meloso';
  font-size: 16px;
  color: #ffffff;
  margin: 0 0 20px 0;
  line-height: 1.5;

  @media screen and ${theme.breakpoints.mobile} {
    font-size: 14px;
  }
`;

export const AddressCheckRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 15px;
  width: 100%;

  & > div:first-child {
    flex: 1;
  }

  @media screen and ${theme.breakpoints.mobile} {
    flex-direction: column;

    & > button {
      width: 100%;
    }
  }
`;

export const Subtitle = styled.p`
  font-family: 'Meloso';
  font-size: 16px;
  color: #333300;
  margin: 0 0 25px 0;
  line-height: 1.5;

  @media screen and ${theme.breakpoints.mobile} {
    font-size: 14px;
  }
`;

export const FieldLabel = styled.label`
  font-family: 'Mix Pudgy Panda';
  font-size: 14px;
  color: #787d2f;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 1px;
  display: block;
  text-align: left;
  margin-bottom: 8px;
`;

export const FieldGroup = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

export const ContinueButtonRow = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
  justify-content: center;
  margin-top: 10px;

  @media screen and ${theme.breakpoints.mobile} {
    flex-direction: column;
  }
`;

export const MarketingText = styled.p`
  font-family: 'Meloso';
  font-size: 14px;
  color: #333300;
  margin: 10px 0 0 0;
  line-height: 1.4;

  @media screen and ${theme.breakpoints.mobile} {
    font-size: 12px;
  }
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  font-family: 'Meloso';
  font-size: 15px;
  color: #333300;
  line-height: 1.4;
  text-align: left;
  width: 100%;
  margin-top: 5px;

  input[type='checkbox'] {
    appearance: none;
    -webkit-appearance: none;
    width: 22px;
    height: 22px;
    min-width: 22px;
    border: 2px solid #787d2f;
    border-radius: 4px;
    margin-top: 2px;
    cursor: pointer;
    position: relative;

    &:checked::after {
      content: '';
      position: absolute;
      top: 2px;
      left: 6px;
      width: 6px;
      height: 12px;
      border: solid #787d2f;
      border-width: 0 2.5px 2.5px 0;
      transform: rotate(45deg);
    }
  }

  @media screen and ${theme.breakpoints.mobile} {
    font-size: 13px;
  }
`;

export const CheckboxSmallText = styled.span`
  font-size: 12px;
  color: #666;

  a {
    color: #666;
    text-decoration: underline;

    &:hover {
      color: #333300;
    }
  }

  @media screen and ${theme.breakpoints.mobile} {
    font-size: 11px;
  }
`;

export const FormContainer = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 25px;
  max-width: 800px;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;

  @media screen and ${theme.breakpoints.mobile} {
    padding-top: 0;
  }
`;

export const AddressInputWrapper = styled.div<{ hasSuggestions?: boolean }>`
  position: relative;
  width: 100%;

  ${({ hasSuggestions }) =>
    hasSuggestions &&
    `
    & input {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom-color: transparent;
    }
  `}
`;

export const SuggestionsList = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  width: 100%;
  text-align: left;
  font-size: 18px;
  font-family: inherit;
  color: #333333;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid rgba(135, 138, 62, 0.5);
  border-top: none;
  border-radius: 0 0 28px 28px;
  overflow: hidden;
  z-index: 10;

  @media screen and ${theme.breakpoints.mobile} {
    width: 100%;
    margin-right: 0;
    font-size: 15px;
  }
`;

export const SuggestionsItem = styled.span`
  display: block;
  padding: 8px 40px;
  line-height: 1.42857143;
  border-bottom: 1px solid #787d2f;
  transition: 0.3s;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: rgba(135, 138, 62, 0.3);
    cursor: pointer;
  }
`;

export const ModalContent = styled(ModalContentWrap)`
  width: 100%;
`;

export const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 147px;
  padding-top: 30px;
  margin: auto;
`;
